<div class="uploader-wrapper" [ngClass]="wrapperClasses">
  <div class="upload-panel" [ngClass]="{'disabled': disableUploader()}" appDragAndDrop
       (fileDropped)="handleFileUpload($event)">
    <div class="icon-wrapper">
      <i></i>
    </div>
    <div class="upload-instructions">
      <h6>Drag a file here or <a (click)="openFileDialog()">browse</a> to upload</h6>
      <p class="upload-types">
        {{ uploadType.filesText }}<br>
        <span [innerHTML]="uploadType.filesInstructions"></span>
      </p>
      <input type="file" #fileInput (change)="onFileChange($event)" [accept]="uploadType.acceptedFileTypes" multiple>
    </div>

    <div class="upload-instructions mobile">
      <h6><a (click)="openFileDialog()">Select a file</a></h6>
      <p class="upload-types">
        {{ uploadType.filesText }}<br>
        {{ uploadType.mobileFileInstructions![0] }}<br>
        {{ uploadType.mobileFileInstructions![1] }}
      </p>
      <input type="file" #fileInput (change)="onFileChange($event)" [accept]="uploadType.acceptedFileTypes" multiple>
    </div>
  </div>
  <div id="uploaded-limit-notification" *ngIf="isMaxTextFilesReached || isMaxFilesReached">
    <app-notification-card [message]="getErrorMessage" type="warning"
      color="#E71316" [closable]="true" (close)="onNotificationClosed()"/>
  </div>

  <div class="uploaded-files-container" *ngIf="uploadedFiles.length">
    <app-uploaded-files-banner-manager [uploadedFiles]="uploadedFiles" (onFileProcessed)="onFileProcessed.emit($event)"
                                       (onUploadingInProgress)="onUploadingInProgress.emit($event)"/>
  </div>
</div>
